import React, { useState } from 'react';
import {
    Box,
    Typography,
    Paper
} from '@mui/material';
import { ReactComponent as GoogleIcon } from '../../icons/google-ads-icon.svg';
import { ReactComponent as MetaIcon } from '../../icons/meta-icon.svg';
import { ReactComponent as TikTokIcon } from '../../icons/tiktok-color-icon.svg';
import { ReactComponent as SmartXIcon } from '../../images/smartclick.svg';
import GoogleIntegration from './GoogleIntegration';
import SmartXIntegration from './SmartXIntegration';

function IntegrationsList({ user, setUser }) {
    const integrations = [
        { name: 'SmartX', id: 'smartx' , component: () => <SmartXIntegration />},
        { name: 'Google Ads', id: 'google', component:() => <GoogleIntegration user={user} setUser={setUser}/> },
        { name: 'Meta Ads', id: 'meta', disabled: true, component: () => <Typography>Em Breve</Typography>},
        { name: 'TikTok for Business', id: 'tiktok', disabled: true, component: () => <Typography>Em Breve</Typography>},
    ]
    const [selectedTab, setSelectedTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const iconMapping = {
        smartx: SmartXIcon,
        google: GoogleIcon,
        meta: MetaIcon,
        tiktok: TikTokIcon
    };
    
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'top',
                height: '100vh',
                boxSizing: 'border-box',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: 'auto',
                }}
            >
                {/* Integrations List (Vertical) */}
                <Paper
                    sx={{
                        width: { xs: '36%', md: '15%' },
                        paddingTop: 2,
                        paddingRight: 1,
                        paddingLeft: 1
                    }}
                >
                    {integrations.map((integration, index) => {
                        const IconComponent = iconMapping[integration.id];
                        return (
                            <Box
                                key={index}
                                sx={{
                                    display: 'flex',
                                    padding: '8px 8px',
                                    marginBottom: 1,
                                    alignItems: 'center',
                                    backgroundColor: selectedTab === index ? 'rgb(235, 235, 235)' : 'transparent',
                                    color: '#333',
                                    borderRadius: 2,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: selectedTab === index ? 'rgb(235, 235, 235)' : '#f5f5f5',
                                    },
                                }}
                                onClick={() => handleTabChange(null, index)}
                            >
                                {IconComponent && (
                                    <IconComponent
                                        style={{
                                            height: 20,
                                            width: 20,
                                            marginRight: 8,
                                        }}
                                    />
                                )}
                                <Box>
                                {integration.name}
                                {integration.disabled && 
                                    <Typography sx={{ fontSize: 10, color: 'gray' }}>
                                        Em breve
                                    </Typography>}
                                </Box>
                            </Box>
                        );
                    })}
                </Paper>

                {/* Content Section - Disabled for now */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'left',
                        alignItems: 'top',
                        marginLeft: 3,
                    }}
                >
                    <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
                        {integrations[selectedTab].component()}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default IntegrationsList;